import type { JSX } from 'react'
import { TextLink } from '#src/components/core/TextLink.tsx'
import { PageLayout } from '#src/components/display/PageLayout.tsx'
import DemoPatientGenerator from '#src/pages/admin-tools/DemoPatientGenerator.tsx'

export function AdminTools(): JSX.Element {
  return (
    <PageLayout title="Admin Tools">
      <DemoPatientGenerator />
      <TextLink to="questionnaire-to-zod">Questionnaire to Zod</TextLink>
    </PageLayout>
  )
}
